import {
  take,
  put,
  call,
  fork,
  select,
  takeEvery,
  all,
} from "redux-saga/effects";
import { deepCloneByJSON } from "../view/cckmweb/common/common";
import {
  GET_USERS_START,
  LOGIN,
  SYSTEM_OVERVIEW_START,
  SESSION_START,
  SCHEDULE_START,
  RX_START,
  TX_START,
  CONNECTION_START,
  RXGROUP_START,
  VW_START,
  USERS_START,
  UGROUP_START,
  PERMISSIONINBATCH_START,
  LOCATION_START,
  TGROUP_START,
  PERMISSIONINBATCH_TX_START,
  PROFILELIST_START,
  SCHEDULELIST_START,
  PERMISSION_UGROUP_START,
  PERMISSION_USER_START,
  VIRTUALTX_START,
} from "../store/types/index";

// import { getUserSuccess } from "../store/actions/users";
import {
  getDashboardSuccess,
  getSessionSuccess,
  getScheduleSuccess,
  getRXSuccess,
  getTXSuccess,
  getConnectionSuccess,
  getRXgroupSuccess,
  getVWSuccess,
} from "../store/actions/dashboard";

import {
  getUserSuccess,
  getUgroupSuccess,
  getPermissionInBatchSuccess,
  getPermissionInBatchTXSuccess,
  getPermissionUgroupSuccess,
  getPermissionUserSuccess,
} from "../store/actions/user&permissions";
import { getLocationSuccess } from "../store/actions/location";
import { getTgroupSuccess, getvirtualTxSuccess } from "../store/actions/tx";
import {
  getProfileListSuccess,
  getScheduleListSuccess,
} from "../store/actions/profile&schedule";

import { errorHandle } from "../store/actions/common";

import { api } from "../services/index";
import { createHashHistory } from "history";
import overview from "../view/cckmweb/data/systemOverview.json";
import session from "../view/cckmweb/data/session.json";
import schedule from "../view/cckmweb/data/schedules.json";
import rx from "../view/cckmweb/data/rxs.json";
import tx from "../view/cckmweb/data/txs.json";
import connection from "../view/cckmweb/data/connections.json";
import rgroups from "../view/cckmweb/data/rgroups.json";
import vws from "../view/cckmweb/data/videowall.json";
import user from "../view/cckmweb/data/users.json";
import ugroup from "../view/cckmweb/data/ugroups.json";
import permissionsInBatch from "../view/cckmweb/data/permissionsInBatch.json";
import location from "../view/cckmweb/data/location.json";
import tgroup from "../view/cckmweb/data/txgroups.json";
import virtualtx from "../view/cckmweb/data/virtualtx.json";
import permissionsInBatchTX from "../view/cckmweb/data/permissionInBatchTx.json";
import profilelist from "../view/cckmweb/data/profileList.json";
import schedulelist from "../view/cckmweb/data/schedulelist.json";
import ugroupPerms from "../view/cckmweb/data/permissionUgroup.json";
import userPerms from "../view/cckmweb/data/permissionUser.json";
const history = createHashHistory({ basename: "/" });

function* loginTest() {
  const action = yield take(LOGIN);
  const data = yield call(api.login, action.options);
  history.push("/dashboard");
  // if (data.ec === 0) {
  //   history.push("/dashboard");
  // } else {
  //   yield put(errorHandle(0));
  // }
}

function* getOverViewWatch() {
  while (true) {
    yield take(SYSTEM_OVERVIEW_START);
    let scene = sessionStorage.scene || 0;
    const data = overview.resp[scene].overview;
    yield put(getDashboardSuccess(data));
  }
}

function* getUsersTestWatch() {
  while (true) {
    yield take(GET_USERS_START);
    const users = yield call(api.getUsers);
    yield put(getUserSuccess(users));
  }
}

function* getSessionWatch() {
  while (true) {
    yield take(SESSION_START);
    const data = session.resp.sessions;
    yield put(getSessionSuccess(data));
  }
}

function* getScheduleWatch() {
  while (true) {
    yield take(SCHEDULE_START);
    const data = schedule.resp.schedules;
    yield put(getScheduleSuccess(data));
  }
}

function* getRXWatch() {
  while (true) {
    yield take(RX_START);
    // let scene = yield select((state) => state.scene);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(rx.resp[scene].RXs);
    yield put(getRXSuccess(data));
  }
}

function* getTXWatch() {
  while (true) {
    yield take(TX_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(tx.resp[scene].TXs);
    yield put(getTXSuccess(data));
  }
}

function* getConnectionWatch() {
  while (true) {
    yield take(CONNECTION_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(connection.resp[scene].connections);
    yield put(getConnectionSuccess(data));
  }
}

function* getRXgGroupWatch() {
  while (true) {
    yield take(RXGROUP_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(rgroups.resp[scene].rgroups);
    yield put(getRXgroupSuccess(data));
  }
}

function* getVWWatch() {
  while (true) {
    yield take(VW_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(vws.resp[scene].presets);
    yield put(getVWSuccess(data));
  }
}

function* getUserWatch() {
  while (true) {
    yield take(USERS_START);
    const data = deepCloneByJSON(user.resp);
    yield put(getUserSuccess(data));
  }
}

function* getUgroupWatch() {
  while (true) {
    yield take(UGROUP_START);
    const data = deepCloneByJSON(ugroup.resp);
    yield put(getUgroupSuccess(data));
  }
}

function* getPermissionsInBatchWatch() {
  while (true) {
    yield take(PERMISSIONINBATCH_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(permissionsInBatch.resp[scene].resp);
    yield put(getPermissionInBatchSuccess(data));
  }
}

function* getLocationWatch() {
  while (true) {
    yield take(LOCATION_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(location.resp[scene].locations);
    yield put(getLocationSuccess(data));
  }
}

function* getTgroupWatch() {
  while (true) {
    yield take(TGROUP_START);
    let scene = sessionStorage.scene || 0;
    // const data = tgroup.resp[scene].targets.filter(
    //   (item) => item.multiViewTarget === true
    // );
    const data = deepCloneByJSON(tgroup.resp[scene].targets);
    yield put(getTgroupSuccess(data));
  }
}

function* getvirtualTxWatch() {
  while (true) {
    yield take(VIRTUALTX_START);
    let scene = sessionStorage.scene || 0;
    // const data = tgroup.resp[scene].targets.filter(
    //   (item) => item.multiViewTarget === false
    // );
    const data = deepCloneByJSON(virtualtx.resp[scene].targets);
    yield put(getvirtualTxSuccess(data));
  }
}

function* getPermissionsInBatchTXWatch() {
  while (true) {
    yield take(PERMISSIONINBATCH_TX_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(permissionsInBatchTX.resp[scene].resp);
    yield put(getPermissionInBatchTXSuccess(data));
  }
}

function* getPermissionsUgroup() {
  while (true) {
    yield take(PERMISSION_UGROUP_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(ugroupPerms.resp[scene].resp);
    yield put(getPermissionUgroupSuccess(data));
  }
}

function* getPermissionUser() {
  while (true) {
    yield take(PERMISSION_USER_START);
    let scene = sessionStorage.scene || 0;
    const data = deepCloneByJSON(userPerms.resp[scene].resp);
    yield put(getPermissionUserSuccess(data));
  }
}

function* getProfileListWatch() {
  while (true) {
    yield take(PROFILELIST_START);
    const data = deepCloneByJSON(profilelist.resp.presets);
    yield put(getProfileListSuccess(data));
  }
}

function* getScheduleListWatch() {
  while (true) {
    yield take(SCHEDULELIST_START);
    const data = deepCloneByJSON(schedulelist.resp.schedules);
    yield put(getScheduleListSuccess(data));
  }
}

export default function* root() {
  // yield all([fork(loginTest), fork(getUsersTest), fork(getOverView)]);
  yield all([
    loginTest(),
    getUsersTestWatch(),
    getOverViewWatch(),
    getSessionWatch(),
    getScheduleWatch(),
    getRXWatch(),
    getTXWatch(),
    getConnectionWatch(),
    getRXgGroupWatch(),
    getVWWatch(),
    getUserWatch(),
    getUgroupWatch(),
    getPermissionsInBatchWatch(),
    getLocationWatch(),
    getTgroupWatch(),
    getvirtualTxWatch(),
    getPermissionsInBatchTXWatch(),
    getProfileListWatch(),
    getScheduleListWatch(),
    getPermissionsUgroup(),
    getPermissionUser(),
  ]);
}
